/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';

import Form from 'forms/_.extend';
import Loading from 'components/Loading/Loading';
import ActionDrawerHeader from 'views/ActionDrawer/components/ActionDrawerHeader/ActionDrawerHeader';

import UnarchiveOwnedAssetForm from './UnarchiveOwnedAssetForm/UnarchiveOwnedAssetForm';
import UnarchiveOwnedAssetSuccess from './UnarchiveOwnedAssetSuccess/UnarchiveOwnedAssetSuccess';
import UnarchiveOwnedAssetError from './UnarchiveOwnedAssetError/UnarchiveOwnedAssetError';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  formData: Object,
  actionDrawerStore: TypeActionDrawerStore,
  asset: Object,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class UnarchiveOwnedAsset extends React.Component<*> {
  createForm = () => {
    const { t, actionDrawerStore }: TypeProps = this.props;

    const asset: Object = this.props.formData;

    const fields: Array<Object> = [
      {
        name: 'unarchiveReason',
        label: t('general:assets.reasons.why_unarchive'),
        fields: [
          {
            name: 'reason',
            label: t('general:reason'),
            rules: 'required|string',
            value: '',
          },
        ],
      },
    ];

    const hooks: Object = {
      onSuccess(data: Object) {
        const { reason }: Object = data.values().unarchiveReason;

        actionDrawerStore.unarchiveAsset(asset.id, {
          activity_reason: reason,
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        name: 'unarchiveOwnedAsset',
      }
    );
  };

  render(): React.Element<*> {
    const { t, actionDrawerStore }: TypeProps = this.props;

    const asset: Object = this.props.formData;

    const title: string = t('general:actions.unarchive_owned_asset');

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={title} />
          <UnarchiveOwnedAssetError asset={asset} />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.success}`}>
          <ActionDrawerHeader title={title} />
          <UnarchiveOwnedAssetSuccess response={actionDrawerStore.response} />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={title} />
        <UnarchiveOwnedAssetForm asset={asset} form={this.createForm()} />
      </div>
    );
  }
}
